import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogExitWithoutSaveAttendance = ({
	showDialogLeavingPage,
	confirmNavigation,
	cancelNavigation,
}) => {
	return (
		<DialogAlertAction
			minWidth="560px"
			show={showDialogLeavingPage}
			toggleShow={cancelNavigation}
			title="¿Deseas salir sin guardar la asistencia?"
			content="La asistencia tomada no se guardará"
		>
			<CustomButton
				variant="quintinary"
				text="Sí, salir"
				width="130px"
				onClick={confirmNavigation}
			/>
			<CustomButton
				variant="quaternary"
				text="No, continuar"
				width="130px"
				onClick={cancelNavigation}
			/>
		</DialogAlertAction>
	);
};

export default DialogExitWithoutSaveAttendance;
